<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closePreview">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'TN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["TNO"]}}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['RS']}}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MUN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MEM"]["U"]}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <!--<template v-else-if="header == 'LFPI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                                <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                            </template>-->
                                            <template v-else-if="header == 'TA'" class="tableCtnRight">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["TA"]}}
                                                <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'EA'" class="tableCtnRight">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["EA"]}}
                                                <i @click="setSortTable('EA')" :class="setSortLogo('EA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["TM"]}}
                                                <i @click="setSortTable('TM')" :class="setSortLogo('TM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["PM"]}}
                                                <i @click="setSortTable('PM')" :class="setSortLogo('PM')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PF'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["PF"]}}
                                            </template>
                                            <template v-else-if="header == 'PT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["PT"]}}
                                            </template>
                                            <template v-else-if="header == 'RURL_TID'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["RURL"]}} / {{getLanguage["MTA"]["TID"]}}
                                            </template>
                                            <template v-else-if="header == 'OP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['OP']}}
                                                <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['CR']['CT']}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ATS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['ATS']}}
                                                <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["BN"]}}
                                                <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'IP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['IP']}}
                                                <i @click="setSortTable('TIP')" :class="setSortLogo('TIP')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'R'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['R']}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MEM"]["UREC"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RURL"]}} :</label>
                                        <div style="display:block;">
                                            <input type="file" name="pic" accept="image/*" @change="onFileSelected" style="overflow: hidden;" ref="RURL" />
                                        </div>
                                        <span class="ErrMsg">{{ ValidationErrMsg('RURL','RURL') }}</span>
                                    </CCol>
                                </CRow>
                                <span class="ErrMsg">{{this.getLanguage["DCUZ"]["MAXFILE"]}}</span>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="SaveReceipt()">
                                        {{this.getLanguage['BTN']['SV']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>

                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["SWR"]}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["BN"]}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="searchExcludeSubAgent" />
                                        <span class="searchLabel ml-1">{{getLanguage["GL"]["ODA"]}}</span>
                                    </div>
                                </div>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="str_FV[0].FV"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="str_FV[13].FV"
                                            openDirection="below"
                                            :disabled="disableSubDD"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <!--<div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                        <treeselect :multiple="false"
                                    :async="true"
                                    :cacheOptions="false"
                                    :load-options="loadMemberOptions"
                                    :options="ddMemberList"
                                    :disable-branch-nodes="true"
                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                    :placeholder="this.utilGetDDLanguage('MEM.U')"
                                    v-model="str_FV[3].FV" />
                    </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--<div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MTA"]["DN"]}} :</span>
                        <treeselect :multiple="false"
                                    :options="dd_dofs"
                                    :placeholder="this.utilGetDDLanguage('MTA.DN')"
                                    :noOptionsText="this.getLanguage['GL']['NOA']"
                                    v-model="str_FV[1].FV" />
                    </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MTA.C')"
                                            v-model="str_FV[5].FV"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["RS"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_status"
                                            :placeholder="this.utilGetDDLanguage('MTA.RS')"
                                            v-model="str_FV[6].FV" />
                            </div>
                            <!--<div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MTA"]["PM"]}} :</span>
                        <treeselect :multiple="false"
                                    :options="dd_pm"
                                    :placeholder="this.utilGetDDLanguage('MTA.PM')"
                                    v-model="str_FV[7].FV" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MTA"]["PF"]}} :</span>
                        <CInput size="sm"
                                :value="str_FV[16].FV" @change="v => str_FV[16].FV = v" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MTA"]["PT"]}} :</span>
                        <CInput size="sm"
                                :value="str_FV[17].FV" @change="v => str_FV[17].FV = v" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MTA"]["OP"]}} :</span>
                        <CInput size="sm"
                                :value="str_FV[9].FV" @change="v => str_FV[9].FV = v" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["GL"]["IP"]}} :</span>
                        <div class="inline">
                            <div class="d-flex">
                                <input type="checkbox" checked @click="IPAddress()" v-model="searchExactIP" />
                                <span class="searchLabel ml-1">{{getLanguage["HELP"]["IPS"]}}</span>
                            </div>
                        </div>
                        <CInput size="sm"
                                :value="str_FV[10].FV" @change="v => str_FV[10].FV = v" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                        <treeselect :key="dd_referralMemberKey"
                                    :multiple="false"
                                    :async="true"
                                    :load-options="loadReferralMemberOptions"
                                    :options="ddReferralMemberList"
                                    :defaultOptions="ddDefaultMemberList"
                                    :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                    :disable-branch-nodes="true"
                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                    :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                    @input="selectReferralMemberOptions"
                                    @deselect="deSelectReferralMemberOptions"
                                    :cacheOptions="false"
                                    v-model="searchReferralUserId" />
                    </div>
                    <div class='searchCol'>
                        <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                        <treeselect :multiple="false"
                                    :options="arry_vdp"
                                    placeholder
                                    v-model="searchVDP" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage['MEM']['MTI']}} :</span>
                        <treeselect :multiple="false"
                                    :options="dd_mt"
                                    :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                    v-model="str_FV[14].FV" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage["MEM"]["RSN"]}} :</span>
                        <CInput size="sm"
                                :value="searchRegisterSourceName" @change="v => searchRegisterSourceName = v" />
                    </div>
                    <div class='searchCol'>
                        <span class='searchLabel'>{{this.getLanguage['MTA']['MW']}} :</span>
                        <treeselect :multiple="false"
                                    :options="dd_manualApply"
                                    :placeholder="this.utilGetDDLanguage('MTA.MD')"
                                    v-model="str_FV[15].FV"
                                    :max-height="200" />
                    </div>-->
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <!--<thead>
                    <tr>
                        <th colspan="100%">{{this.getLanguage['MTA']['WRS']}}</th>
                    </tr>
                </thead>
                <tbody>
                <td colspan="100%" v-if=" arry_wsl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                <tr v-if=" arry_wsl.length != 0" @click="bool_showSummary = !bool_showSummary" class='reportTotal kema-eft'>
                    <td style="width:20%" class="tableCtnRight">{{this.getLanguage['MTA']['GT']}}</td>
                    <td style="width:20%" class="textAlignCenter">{{ formatNumber(TotalByCurrency.TotalWithdraw, 0) }}</td>
                    <td style="width:20%" class="textAlignCenter">{{ formatNumber(TotalByCurrency.TotalMember, 0) }}</td>
                    <td style="width:20%" class="textAlignCenter">{{ formatNumber(TotalByCurrency.TotalNewMember, 0) }}</td>
                    <td style="width:20%" :style="renderActivityStyle(2)" class="tableCtnRight">{{ formatNumber(TotalByCurrency.TotalAmount, 2, "USD") }}</td>
                </tr>
                </tbody>
                <thead v-if="bool_showSummary">
                    <tr>
                        <th style="width:20%">{{this.getLanguage['MTA']['C']}}</th>
                        <th style="width:20%" class="textAlignCenter">{{this.getLanguage['MTA']['TWC']}}</th>
                        <th style="width:20%" class="textAlignCenter">{{this.getLanguage['MTA']['UM']}}</th>
                        <th style="width:20%" class="textAlignCenter">{{this.getLanguage['MTA']['UNM']}}</th>
                        <th style="width:20%" class="tableCtnRight">{{this.getLanguage['MTA']['FTA']}}</th>
                    </tr>
                </thead>
                <tbody v-if="bool_showSummary">
                <td colspan="100%" v-if=" arry_wsl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                <tr v-for="(data,index) in arry_wsl">
                    <td>{{ renderCurrency(data.ISOC) }}</td>
                    <td class="textAlignCenter">{{ formatNumber(data.TD, 0) }}</td>
                    <td class="textAlignCenter">{{ formatNumber(data.TUD, 0) }}</td>
                    <td class="textAlignCenter">{{ formatNumber(data.TUNM, 0) }}</td>
                    <td :style="renderActivityStyle(2)" class="tableCtnRight">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                </tr>
                </tbody>-->
                        <!--<br />
                <br />
                <thead>
                    <tr>
                        <th colspan="100%">{{this.getLanguage['MTA']['WSBO']}}</th>
                    </tr>
                </thead>
                <tbody>
                <td colspan="100%" v-if=" arry_summaryByOperator.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                <tr v-if="arry_summaryByOperator.length != 0" @click="bool_showSummary1 = !bool_showSummary1" class='reportTotal kema-eft'>
                    <td style="width:20%" class="tableCtnRight">{{this.getLanguage['MTA']['GT']}}</td>
                    <td style="width:20%" class="textAlignCenter">{{ formatNumber(TotalByOperator.TotalFirstWithdrawCount, 0) }}</td>
                    <td style="width:20%" :style="renderActivityStyle(2)" class="tableCtnRight">{{ formatNumber(TotalByOperator.TotalFirstWithdrawAmount, 2, "USD") }}</td>
                    <td style="width:20%" class="textAlignCenter">{{ formatNumber(TotalByOperator.TotalAllWithdrawCount, 0) }}</td>
                    <td style="width:20%" :style="renderActivityStyle(2)" class="tableCtnRight">{{ formatNumber(TotalByOperator.TotalAllWithdrawAmount, 2, "USD") }}</td>
                </tr>
                </tbody>
                <thead v-if="bool_showSummary1">
                    <tr>
                        <th style="width:20%" rowspan="2">{{this.getLanguage["MTA"]["OP"]}}</th>
                        <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171); width: 40%;">{{this.getLanguage["MEM"]["FW"]}}</th>
                        <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171); width: 40%;">{{this.getLanguage["MEM"]["TW"]}}</th>
                    </tr>
                    <tr>
                        <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171);">#</th>
                        <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                        <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171);">#</th>
                        <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                    </tr>
                </thead>
                <tbody v-if="bool_showSummary1">
                <td colspan="100%" v-if=" arry_summaryByOperator.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                <tr v-for="(data,index) in arry_summaryByOperator">
                    <td>{{ data.UB }}</td>
                    <td class="textAlignCenter">{{ formatNumber(data.TFDC, 0) }}</td>
                    <td :style="renderActivityStyle(2)" class="tableCtnRight">{{ formatNumber(data.TFDA, 2, data.CS) }}</td>
                    <td class="textAlignCenter">{{ formatNumber(data.TD, 0) }}</td>
                    <td :style="renderActivityStyle(2)" class="tableCtnRight">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                </tr>
                </tbody>-->
                    </table>
                </div>
            </div>

            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['MTA']['WRL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["TNO"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MUN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["U"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <!--<template v-else-if="header == 'LFPI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>-->
                                    <template v-else-if="header == 'TA'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["TA"]}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'EA'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["EA"]}}
                                        <i @click="setSortTable('EA')" :class="setSortLogo('EA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["TM"]}}
                                        <i @click="setSortTable('TM')" :class="setSortLogo('TM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["PM"]}}
                                        <i @click="setSortTable('PM')" :class="setSortLogo('PM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["PF"]}}
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["PT"]}}
                                    </template>
                                    <template v-else-if="header == 'RURL_TID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["RURL"]}} / {{getLanguage["MTA"]["TID"]}}
                                    </template>
                                    <template v-else-if="header == 'OP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['OP']}}
                                        <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CR']['CT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['ATS']}}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["BN"]}}
                                        <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('TIP')" :class="setSortLogo('TIP')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'R'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['R']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["TNO"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['RS']}}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MUN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["U"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <!--<template v-else-if="header == 'LFPI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>-->
                                    <template v-else-if="header == 'TA'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["TA"]}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'EA'" class="tableCtnRight">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["EA"]}}
                                        <i @click="setSortTable('EA')" :class="setSortLogo('EA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["TM"]}}
                                        <i @click="setSortTable('TM')" :class="setSortLogo('TM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["PM"]}}
                                        <i @click="setSortTable('PM')" :class="setSortLogo('PM')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["PF"]}}
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["PT"]}}
                                    </template>
                                    <template v-else-if="header == 'RURL_TID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["RURL"]}} / {{getLanguage["MTA"]["TID"]}}
                                    </template>
                                    <template v-else-if="header == 'OP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['OP']}}
                                        <i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CR']['CT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ATS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['ATS']}}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["BN"]}}
                                        <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['IP']}}
                                        <i @click="setSortTable('TIP')" :class="setSortLogo('TIP')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'R'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['R']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_wrl.length == 0">{{getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_wrl" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'TN'">
                                    {{ data.AGTI }}
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <span class="grid-line">{{ renderStatus(data.RS) }}</span>
                                    <span class="grid-line rejectReason" v-if="data.RS==3">{{ renderRejectReason(data.RR) }}</span>
                                </template>
                                <template v-else-if="header == 'MUN'">
                                    <span v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <span class="grid-line" v-if="data.U != null && data.U != ''">
                                            <div class="custom_tooltip">
                                                <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.TW == 0">
                                                <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.HTWT">
                                                <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.RP">
                                                <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <!--<div class="float-right ml-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
        </svg>
    </div>-->
                                        </span>
                                        <span v-else>-</span>
                                    </span>
                                    <span v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <span class="grid-line" v-if="data.U != null && data.U != ''">
                                            <div class="custom_tooltip">
                                                <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.TW == 0">
                                                <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.HTWT">
                                                <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom_tooltip" v-if="data.RP">
                                                <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                                <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <!--<div class="float-right ml-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
        </svg>
    </div>-->
                                        </span>
                                        <span v-else>-</span>
                                    </span>
                                </template>
                                <!--<template v-else-if="header == 'LFPI'">
                                    <div style="text-align:center;display:block">
                                        <span v-if="getUserInfo.AT!=4">
                                            <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                            </span>
                                            <span v-else-if="data.TSI > 0 && (isSENS == 1 && data.AGI == curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span v-else-if="getUserInfo.AT==4">
                                            <span v-if="data.SUBATSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span v-else-if="data.SUBATSI > 0 && (isSENS == 1 && data.AGI == curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span class="grid-line" v-else>-</span>
                                        <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                            <thead>
                                                <tr>
                                                    <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                    <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row,index1) in arry_systemId[data.I]">
                                                    <tr style="text-align: left;">
                                                        <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                        <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td>
                                                                            <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>-->
                                <template v-else-if="header == 'TA'">
                                    <span v-if="data.PM != 7" :style="renderActivityStyle(2)">
                                        {{ formatNumber(data.TA, 2, data.CS) }}
                                    </span>
                                    <span v-else-if="data.PM == 7">
                                        <span class="grid-line" :style="renderActivityStyle(2)">{{ formatNumber(data.TA, 2, data.CS) }}</span>
                                        <span class="grid-line" :style="renderActivityStyle(2)">{{ data.CoinValue }}</span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'EA'">
                                    <span :style="renderActivityStyle(2)">
                                        {{ formatNumber(data.EA, 2, data.CS) }}
                                    </span>
                                </template>
                                <template v-else-if="header == 'TM'">
                                    {{ ConvertTransMethod(data.TM) }}
                                </template>
                                <template v-else-if="header == 'PM'">
                                    {{ renderPaymentMethod(data.PM, data.IAW) }}
                                </template>
                                <template v-else-if="header == 'PF'">
                                    <span v-if="data.PM==13">{{getLanguage['ACO']['TUP']}}</span>
                                    <span v-if="data.PM==26">{{getLanguage['ACO']['TUP']}}</span>
                                    <span v-if="data.PM==39">{{getLanguage['ACO']['LP']}}</span>
                                    <span v-if="data.PM==43">{{getLanguage['ACO']['BCP']}}</span>
                                    <span v-if="data.PM==46">{{getLanguage['ACO']['FPG']}}</span>
                                    <span v-if="data.PM==47">{{getLanguage['ACO']['PGA']}}</span>
                                    <span v-if="data.PM==49">{{getLanguage['ACO']['PP']}}</span>
                                    <span v-if="data.PM==51">{{getLanguage['ACO']['DN']}}</span>
                                    <span v-if="data.PM==53">{{getLanguage['ACO']['P918']}}</span>
                                    <span v-if="data.PM==55">{{getLanguage['ACO']['UP']}}</span>
                                    <span v-if="data.PM==56 || data.PM==58 || data.PM==59">{{getLanguage['ACO']['OKP']}}</span>
                                    <span v-if="data.PM==57">{{getLanguage['ACO']['MGP']}}</span>
                                    <span v-if="data.BankList != null && data.BankList.length > 0">
                                        <span v-for="bank in data.BankList">
                                            <span class="grid-line">{{ bank.BN }}</span>
                                            <span class="grid-line">{{ HideInfo(getUserInfo.IHMI, bank.BA, 4) }}</span>
                                            <span class="grid-line">({{ HideInfo(getUserInfo.IHMI, bank.BAN, 4) }})</span>
                                        </span>
                                    </span>
                                    <span v-else-if="data.TM == 0 && data.PM == 0 || data.TM == 0 && data.PM == 1">{{getLanguage['MWB']['NFBD']}}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'PT'">
                                    <span v-if="data.AB != '' || data.ABA != '' || data.ABN != ''">
                                        <div style="float:left">
                                            <span class="grid-line">{{ data.AB }}</span>
                                            <span class="grid-line">{{ data.ABA }}</span>
                                            <span class="grid-line">{{ data.ABN }}</span>
                                            <!--<span class="grid-line">{{ HideInfo(getUserInfo.IHMI, data.ABA, 4) }}</span>
                                    <span class="grid-line">{{ HideInfo(getUserInfo.IHMI, data.ABN, 4) }}</span>-->
                                        </div>
                                        <!--<div v-if="data.MBQRC" style="float:right;margin-left:5px;">
                                    <img class="card-img-top h-100" style="width: 50px; cursor: pointer;" alt="member-bank-qrcode" @click="setPreview(data.MBQRC)" :src="data.MBQRC" />
                                </div>-->
                                    </span>
                                    <span v-else>-</span>
                                </template>
                                <template v-else-if="header == 'RURL_TID'">
                                    <div v-if="(data.RURL != '' || (data.TID && data.TID != 'undefined')) && data.PM != 7 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.RURL)" v-if="data.RURL != ''">
                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                        </a>
                                        <span v-if="data.TID && data.TID != 'undefined'" class="grid-line">{{ data.TID }}</span>
                                        <button v-if="data.RURL == ''" @click="UploadReceipt(data)" class="btn btn-sm btn-dark">Upload Receipt</button>
                                    </div>
                                    <div v-else-if="(data.RURL != '' || (data.TID && data.TID != 'undefined')) && data.PM != 7 && (isSENS == 1 && data.AGI != curAGI)">
                                        <a href="javascript:void(0)" style="color:blue" v-if="data.RURL != ''">
                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                        </a>
                                        <span v-if="data.TID && data.TID != 'undefined'" class="grid-line">{{ data.TID }}</span>
                                        <button v-if="data.RURL == ''" @click="UploadReceipt(data)" class="btn btn-sm btn-dark">Upload Receipt</button>
                                    </div>
                                    <div v-else-if="data.PM==7">
                                        <a :href="data.TranHashURL" target="_blank">
                                            <u>{{ data.RURL }}</u>
                                        </a>
                                    </div>
                                    <div v-else>
                                        <button @click="UploadReceipt(data)" class="btn btn-sm btn-dark">Upload Receipt</button>
                                    </div>
                                </template>

                                <template v-else-if="header == 'OP'">
                                    <div v-if="data.ATPC!=''">{{ data.AT }} ({{ data.ATPC }})</div>
                                </template>
                                <template v-else-if="header == 'CT'">
                                    {{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'ATS'">
                                    {{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <Span class="saggroupname" v-if="data.SAGGN != ''">{{ data.SAGGN }}</Span>
                                    <span class="grid-line">{{ data.DN }}</span>
                                </template>
                                <template v-else-if="header == 'IP'">
                                    <router-link :to="{ path:'/M/ML/SameTransactionIP', query:{ ip: data.TIP}}">{{ data.TIP }}</router-link>
                                </template>
                                <template v-else-if="header == 'R'">
                                    <span>
                                        <span class="grid-line depositremarkwidth">{{ data.R }}</span>
                                    </span>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constRejectReasonW } from '@/modules/Constant.js'
    import Vue from 'vue'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    //Vue.use(require('vue-shortkey'))
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true, //Loading Visible
                bool_showSummary1: true, //Loading Visible
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                searchRegisterSourceName: null,
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [
                    { F: "AGI" },
                    { F: "DI" },
                    {
                        F: "UTS",
                        FV: {
                            startDate: this.getTodayDate(),
                            endDate: this.getMonthEndDate()
                        }
                    },
                    { F: "MI" },
                    { F: "TT", FV: 2 },
                    { F: "CI_csv", FA: true },
                    { F: "RS", FV: 2 },
                    { F: "PM" },
                    { F: "TM" },
                    { F: "AT" },
                    { F: "TIP" },
                    { F: "TIP_WC" },
                    { F: "RI" },
                    { F: "SAGAGI" },
                    { F: "TN" },
                    { F: "IMA" },
                    { F: "BN" },
                    { F: "MB" }
                ], //Filter Value
                arry_wrl: [], //withdraw report list
                arry_wsl: [], //withdraw summary list
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: null,
                rtSubBrand: 0,
                dd_currency: [],
                dd_status: [],
                dd_pm: [],
                dd_tm: [], // transaction type
                dd_dofs: [], // Domain Option for search
                ddMemberList: [],
                needResetHeaders: false,
                defaultReportHeaders: ['NO','TN','RS', 'BN', 'MUN', 'TA', 'EA', 'TM', 'PM', 'PF', 'PT', 'RURL_TID', 'OP', 'CT', 'ATS', 'IP', 'R'],
                reportHeaders: [],
                constAccessType: constAccessType,
                arry_visitorMembers: [],
                arry_systemId: [],
                opened: [],
                searchExactIP: true,
                dd_referralMemberKey: 0,
                ddReferralMemberList: null,
                ddDefaultMemberList: null,
                searchReferralUserId: null,
                searchReferralUsername: null,
                hideBrand: false,
                searchAgi: "",
                searchExcludeSubAgent: false,
                arry_vdp: [],
                //arry_vdp: [{ id: "", label: "All" }, { id: "1", label: "Yes" }, { id: "0", label: "No" }],
                searchVDP: null,
                disableSubDD: false,
                dd_mt: [], // member type
                dd_manualApply: [],
                //dd_manualApply: [
                //    {
                //        id: "1",
                //        label: "Yes"
                //    },
                //    {
                //        id: "0",
                //        label: "No"
                //    }],
                bool_fullPreview: false,
                bool_isDDMV: false,
                selectedFile: null,
                bool_isAMV: false, // Add Modal Visible
                bool_CV: false, // Check Validation
                obj_ad: null,
                bool_loadSummary: false,
                TotalByCurrency: {
                    TotalWithdraw: 0,
                    TotalMember: 0,
                    TotalNewMember: 0,
                    TotalAmount: 0
                },
                TotalByOperator: {
                    TotalFirstWithdrawCount: 0,
                    TotalFirstWithdrawAmount: 0,
                    TotalAllWithdrawCount: 0,
                    TotalAllWithdrawAmount: 0
                },
                arry_summaryByOperator: [],
            }
        },
        created() {
            this.reportHeaders = null;
            if (window.location.pathname == '/W/SWR') {
                this.$parent.showSubMenu = 'W';
                this.$parent.showActiveMenu = 'W.SWR';
            }
            else {
                this.$parent.showSubMenu = 'R';
                this.$parent.showSubSubMenu = 'RS2';
                this.$parent.showActiveMenu = 'R.SWR';
                this.hideBrand = this.getUserInfo.IHAGIF;
            }
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            if (this.$route.query.ci) {
                this.str_FV[5].FV = [];
                this.str_FV[5].FV.push(this.$route.query.ci);
            }
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);

            this.getAgentGroup();
            this.getCurrencyList();
            this.getStatusList();
            this.getPMList();
            this.getTMList();
            this.getManualApply();
            this.getVDP();
            if (this.$route.path != this.$route.fullPath) {
                this.bool_loadSummary = true;
                if (this.$route.query.agi) {
                    this.str_FV[0].FV = [this.$route.query.agi];
                    var split = this.$route.query.agi.split("-");
                    if (split.length == 2) {
                        this.searchAgi = split[1];
                    }
                    else {
                        this.searchAgi = split[0];
                    }
                }
                this.getWithdrawReportList();
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        watch: {
            getLanguage() {
                this.getStatusList();
                this.getPMList();
                this.getTMList();
                this.getWithdrawReportList();
                this.getManualApply();
                this.getCurrencyList();
                this.getVDP();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/WithdrawReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                        if (that.hideBrand) {
                                            var myIndex = that.defaultReportHeaders.indexOf('BN');
                                            if (myIndex !== -1) {
                                                that.defaultReportHeaders.splice(myIndex, 1);
                                            }
                                            var myIndex = that.reportHeaders.indexOf('BN');
                                            if (myIndex !== -1) {
                                                that.reportHeaders.splice(myIndex, 1);
                                            }
                                        }
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/WithdrawReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
        },
        methods: {
            getDateRange(showThisYear = false) {
                var that = this;
                var dateRange = {
                    [that.getLanguage['MEM']['TODAY']]: [moment(), moment()],
                    [that.getLanguage['MEM']['YESDAY']]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    [that.getLanguage['MEM']['TWEEK']]: [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                    [that.getLanguage['MEM']['TMON']]: [moment().startOf('month'), moment().endOf('month')],
                    [that.getLanguage['MEM']['TYEAR']]: [moment().startOf('year'), moment().endOf('year')],
                    [that.getLanguage['MEM']['LWEEK']]: [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
                    [that.getLanguage['MEM']['LMON']]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                }
                if (!showThisYear)
                    delete dateRange[that.getLanguage['MEM']['TYEAR']];
                return dateRange;
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            getManualApply() {
                this.dd_manualApply = [{ id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            getVDP() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] },{ id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.bool_loadSummary = false;
                this.getWithdrawReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.str_FV[2].FV) {
                    if (this.str_FV[2].FV.startDate != "") {
                        var z = this.set90daysDateSearch(this.str_FV[2].FV.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.bool_loadSummary = true;
                this.getWithdrawReportList();
            },
            getStatusList() {
                this.dd_status = [
                    { id: '1', label: this.getLanguage['MTA']['AC1'] },
                    { id: '2', label: this.getLanguage['MTA']['AC2'] },
                    { id: '3', label: this.getLanguage['MTA']['AC3'] },
                    { id: '4', label: this.getLanguage['MTA']['AC4'] },
                    { id: '5', label: this.getLanguage['MTA']['AC5'] },];
            },
            getPMList() {
                this.dd_pm = [
                    { id: '1', label: this.getLanguage['MTA']['WPM1'] },
                    { id: '3', label: this.getLanguage['MTA']['WPM3'] },
                    { id: '7', label: 'Crypto Withdrawal' },
                    { id: '13', label: this.getLanguage['MTA']['WPM13'] },
                    { id: '26', label: this.getLanguage['MTA']['WPP26'] },
                    { id: '39', label: this.getLanguage['MTA']['WPM39'] },
                    { id: '42', label: this.getLanguage['MTA']['WPM42'] },
                    { id: '43', label: this.getLanguage['MTA']['WPM43'] },
                    { id: '46', label: this.getLanguage['MTA']['WPM46'] },
                    { id: '47', label: this.getLanguage['MTA']['WPM47'] },
                    { id: '49', label: this.getLanguage['MTA']['WPM49'] },
                    { id: '51', label: this.getLanguage['MTA']['WPM51'] },
                    { id: '53', label: this.getLanguage['MTA']['WPM53'] },
                    { id: '55', label: this.getLanguage['MTA']['WPM55'] },
                    { id: '56', label: this.getLanguage['MTA']['WPM56'] },
                    { id: '57', label: this.getLanguage['MTA']['WPM57'] },
                    { id: '58', label: this.getLanguage['MTA']['WPM58'] },
                    { id: '59', label: this.getLanguage['MTA']['WPM59'] }];

            },
            getTMList() {
                this.dd_tm = [
                    { id: '0', label: this.getLanguage['MTA']['TM0'] },
                    { id: '1', label: this.getLanguage['MTA']['TM1'] },
                    { id: '2', label: 'Crypto' }];
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchAgi) {
                    agi = this.searchAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCurrency(d.dropdownlist[i].label);
                            }
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            renderCurrency(ISOC) {
                return this.getLanguage['DB'][ISOC];
            },
            getAgentGroup() {
                var that = this;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
                this.getDataApi(`/api/dd/mtname`,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = "";
                    if (this.str_FV[13].FV) {
                        agi = this.str_FV[13].FV;
                    } else if (this.str_FV[0].FV) {
                        agi = this.str_FV[0].FV;
                    }

                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.str_FV[0].FV) {
                    parentAGI = this.str_FV[0].FV;
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.str_FV[13].FV = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.bool_loadSummary = true;
                        that.getWithdrawReportList();
                    });
            },
            AgentGroupChangefs(value) {
                this.dd_dofs = [];
                this.dd_mt = [];
                this.disableSubDD = false;
                this.str_FV[0].FV = null;
                this.str_FV[13].FV = null;
                this.searchAgi = "";
                if (value != undefined) {
                    var that = this;
                    //var agi = 0;

                    if (value != "") {
                        //agi = value.split("-")[1];
                        var temp = "";
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.searchAgi = temp;
                        that.str_FV[0].FV = that.searchAgi;
                        this.getDataApi(`/api/dd/dn/` + this.searchAgi,
                            function (d, s) {
                                if (s) {
                                    that.dd_dofs = d.dropdownlist;
                                    //that.str_FV[0].FV = that.searchAgi;
                                    //that.str_FV[13].FV = null;
                                }
                            });
                        if (value.length > 1) {
                            this.disableSubDD = true;
                        }
                    } else {
                        this.searchAgi = 0;
                    }
                } else {
                    this.searchAgi = 0;
                    this.str_FV[0].FV = null;
                }
                this.str_FV[5].FV = null;
                this.dd_currency = null;
                this.getCurrencyList();

                this.getDataApi(`/api/dd/mtname/` + this.searchAgi,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });
            },
            SubAgentGroupChangefs(value) {
                this.dd_dofs = [];
                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value;
                    }

                    this.getDataApi(`/api/dd/dadn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[13].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[13].FV = null;
                }
            },
            getWithdrawReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 13) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'UTS' && this.str_FV[i].FV != '') {

                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "f[UTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[UTS_to]=" + cts_to;
                            }

                        }
                        //else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                        //    var agi = 0;
                        //    var value = this.str_FV[i].FV;
                        //    if (value != "") {
                        //        agi = value.split("-")[1];
                        //    }
                        //    path += "&f[AGI]=" + agi;

                        //}
                        else if (this.str_FV[i].F != 'TIP' && this.str_FV[i].F != 'TIP_WC') {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                if (this.searchExactIP) {
                    if (this.str_FV[10].FV) {
                        path += "&f[TIP]=" + this.str_FV[10].FV;
                    }
                } else {
                    if (this.str_FV[10].FV) {
                        path += "&f[TIP_WC]=" + this.str_FV[10].FV;
                    }
                }

                if (this.searchReferralUserId != null) {
                    path += "&f[RI]=" + this.searchReferralUserId;
                }

                if (this.str_FV[13].FV) {
                    path += "&f[AGI]=" + this.str_FV[13].FV;
                }
                if (this.searchAgi) {
                    path += "&f[AGI_in]=" + this.searchAgi;
                }
                if (this.searchExcludeSubAgent) {
                    path += "&f.SAGI=0";
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                this.getDataApi(`/api/agtrans/lr?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setWithdrawReportList(d.D);
                            that.resizeTableHead();
                        }
                    });
                //if (this.bool_loadSummary) {
                //    this.getDataApi(`/api/agtrans/lr/total?${path}`,
                //        function (data) {
                //            that.setWithdrawSummaryList(data.R1);
                //            //that.setWithdrawSummaryByOperator(data.R2);
                //        });
                //}
            },
            saveToExcel() {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV && i != 0 && i != 13) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'UTS' && this.str_FV[i].FV != '') {

                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "f[UTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[UTS_to]=" + cts_to;
                            }

                        }
                        //else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                        //    var agi = 0;
                        //    var value = this.str_FV[i].FV;
                        //    if (value != "") {
                        //        agi = value.split("-")[1];
                        //    }
                        //    path += "&f[AGI]=" + agi;

                        //}
                        else if (this.str_FV[i].F != 'TIP' && this.str_FV[i].F != 'TIP_WC') {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                /*
                this.getDataApi(`/api/memtrans/lr?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setWithdrawReportList(d.D);
                        }
                    });
                */

                if (this.searchExactIP) {
                    if (this.str_FV[10].FV) {
                        path += "&f[TIP]=" + this.str_FV[10].FV;
                    }
                } else {
                    if (this.str_FV[10].FV) {
                        path += "&f[TIP_WC]=" + this.str_FV[10].FV;
                    }
                }
                if (this.searchReferralUserId != null) {

                    path += "&f[RI]=" + this.searchReferralUserId;
                }

                if (this.str_FV[13].FV) {
                    path += "&f[AGI]=" + this.str_FV[13].FV;
                }
                if (this.searchAgi) {
                    path += "&f[AGI_in]=" + this.searchAgi;
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                window.open('/api/agtrans/lrwe?' + path, '_blank');

            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            setWithdrawReportList(data) {
                this.arry_wrl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setWithdrawSummaryList(data) {
                this.arry_wsl = data;
                this.TotalByCurrency.TotalWithdraw = 0;
                this.TotalByCurrency.TotalMember = 0;
                this.TotalByCurrency.TotalNewMember = 0;
                this.TotalByCurrency.TotalAmount = 0;
                //this.decimal_gt = 0;
                if (this.arry_wsl.length != 0) {
                    for (var i = 0; i < this.arry_wsl.length; i++) {
                        //this.decimal_gt += this.arry_wsl[i].GT;
                        this.TotalByCurrency.TotalWithdraw += this.arry_wsl[i].TD;
                        this.TotalByCurrency.TotalMember += this.arry_wsl[i].TUD;
                        this.TotalByCurrency.TotalNewMember += this.arry_wsl[i].TUNM;
                        this.TotalByCurrency.TotalAmount += this.arry_wsl[i].GT;
                    }
                }
            },
            setWithdrawSummaryByOperator(data) {
                this.arry_summaryByOperator = data;
                this.TotalByOperator.TotalFirstWithdrawCount = 0;
                this.TotalByOperator.TotalFirstWithdrawAmount = 0;
                this.TotalByOperator.TotalAllWithdrawCount = 0;
                this.TotalByOperator.TotalAllWithdrawAmount = 0;
                if (this.arry_summaryByOperator.length != 0) {
                    for (var i = 0; i < this.arry_summaryByOperator.length; i++) {
                        this.TotalByOperator.TotalFirstWithdrawCount += this.arry_summaryByOperator[i].TFDC;
                        this.TotalByOperator.TotalFirstWithdrawAmount += this.arry_summaryByOperator[i].GTFDA;
                        this.TotalByOperator.TotalAllWithdrawCount += this.arry_summaryByOperator[i].TD;
                        this.TotalByOperator.TotalAllWithdrawAmount += this.arry_summaryByOperator[i].GT;
                    }
                }
            },
            ConvertTransMethod(value) {
                return this.dd_tm[value].label;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.bool_loadSummary = false;
                this.getWithdrawReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            renderIsManual(value) {
                return this.getLanguage['MTAD'][value];
            },
            renderStatus(statusCode) {
                return this.getLanguage['MTA']['AC' + statusCode];
            },
            renderPaymentMethod(pm, iaw) {
                return iaw == 1 ? this.getLanguage['MTA']['WPMIAW'] : this.getLanguage['MTA']['WPM' + pm];
            },
            renderRejectReason(rejectReason) {
                const found = constRejectReasonW.some(el => el.id === rejectReason);

                if (found) {
                    for (var d of constRejectReasonW) {
                        if (d.id == rejectReason) {
                            rejectReason = d.label;
                        }
                    }
                }

                return rejectReason;
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: this.getTodayDate(),
                    endDate: this.getMonthEndDate()
                };
            },
            renderClassName(header) {
                if (header == 'MUN') {
                    return "kema-eft";
                } else if (header == 'TA' || header == 'EA') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('BN')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },
            IPAddress() {
                if (this.searchExactIP) {
                    this.searchExactIP = false;
                } else {
                    this.searchExactIP = true;
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            setPreview(img) {
                this.previewUrl = img;
                this.bool_fullPreview = true;
            },
            closePreview() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            UploadReceipt(data) {
                this.obj_ad = Object.assign({}, data);
                this.obj_ad['RURL'] = null;
                this.bool_isAMV = true;
                this.bool_CV = false;
            },
            SaveReceipt() {
                this.bool_CV = true;
                this.$v.obj_ad.$touch();
                if (!this.$v.obj_ad.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApiWithAttach(`/api/memtrans/urf`, this.obj_ad,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.selectedFile = null;
                                that.obj_ad = null;
                                that.getWithdrawReportList();
                            }
                        });
                } else {
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_ad"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 6 , [".jpg", ".jpeg", ".png"]);
                this.obj_ad["RURL"] = this.selectedFile;
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_ad[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            goToPage() {
                this.$router.push("/W/WR");
            },
        },
        validations: {
            obj_ad: {
                RURL: { required },
            }
        },

    }

</script>

<style>
    .FloatLeft {
        float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/SubAgentWithdrawReport.vue